#!/usr/bin/env node

import startServer from '../index';

startServer();
